
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class AyudaMedicaService
{
    constructor(public http: HttpClient, ) { }

    traePostulantes(rut: any)
    {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`,
               { headers: this.armaCabecera() }).toPromise();
    }
    traeTipoEvento(){
        return this.http.get(`${environment.urlApiAyudaMedica}/getTipoEvento`,
               { headers: this.armaCabecera() }).toPromise();
    }

    cupoSumatoriaOcupado(idAfiliado: any, idCarga: any, idSolicitud: any,idTipoEvento: any){
        return this.http.get(`${environment.urlApiAyudaMedica}/getCupoSumatoriaOcupado/${idAfiliado}/carga/${idCarga}/solicitud/${idSolicitud}/tipoEvento/${idTipoEvento}`,
               { headers: this.armaCabecera() }).toPromise();
    }


    traeProteccionSalud(){
        return this.http.get(`${environment.urlApiAyudaMedica}/getProteccionSalud`,
               { headers: this.armaCabecera() }).toPromise();
    }

    traeSistemaSalud(){
        return this.http.get(`${environment.urlApiAyudaMedica}/getSistemaSalud`,
               { headers: this.armaCabecera() }).toPromise();
    }

    traeAyudasGuardadas(afiliado: any, beneficiario:any){
        
        return this.http.post(`${environment.urlApiAyudaMedica}/getAyudasIngresadas/`,
        { 
            filtroIngresado:true,
            idAfiliado:afiliado,
            idCarga:beneficiario
        }, { headers: this.armaCabecera() }).toPromise();
    }
    agregarAyuda(ayuda:any,idUsuario:any){
       
        return this.http.post(`${environment.urlApiAyudaMedica}/ingresar/ayuda/`,
        {
            idAyudaMedica:0,
            idUsuario: idUsuario,
            idCarga:ayuda.beneficiario,
            idAfiliado:ayuda.afiliado,
            idProducto: 6,
            idTipoEvento:ayuda.tipoEvento,
            tipoDocumento: ayuda.tipoDocumento,
            fechaEvento:ayuda.fechaEvento,
            montoCopago: ayuda.montoCopago,
            montoReembolso: ayuda.montoReembolso,
            montoReembolsoSistema: ayuda.montoReembolsoSistema,
            montoOtroReembolso: ayuda.montoOtroReembolso,
            montoTotalGasto: ayuda.montoTotalGasto,
            proteccionSalud: ayuda.proteccionSalud,
            txtTratamiento: ayuda.txtTratamiento,
            txtDiagnostico: ayuda.txtDiagnostico,
            archivoAdjunto: ayuda.archivo
      
        }, { headers: this.armaCabecera() }).toPromise();
    }
  
    editarDocumentoAyudaMedica(data: any, fechaDocumento: any, rutPrestador: any, dvPrestador: any, idUsuario: any, idCarga: any, idUsuarioSesion: any) {
     
        return this.http.put(`${environment.urlApiAyudaMedica}/ayudamedica/documento`,
            {
                idDocumentoAyudaMedica: data.idDocumentoAyudaMedica,
                idAyudaMedica: data.idAyudaMedica,
                idTipoEvento: data.idTipoEvento,
                idTipoDocumento: data.idTipoDocumento,
                tipoDocumento: data.tipoDocumento,
                diagnostico: data.diagnostico,
                tratamiento: data.tratamiento,
                montoCopago: data.montoCopago,
                montoReembolso: data.montoReembolso,
                montoReembolsoSistema: data.montoReembolsoSistema,
                montoTotalGasto: data.montoTotalGasto,
                montoOtroReembolso: data.montoOtroReembolso,
                rutPrestador: rutPrestador,
                dvPrestador:dvPrestador,
                nroDocumento: data.nroDocumento,
                sistemaSalud: data.sistemaSalud,
                tipoEvento: data.tipoEvento,
                otroSistemaSalud: data.otroSistemaSalud,
                otroProteccion: data.otroProteccion,
                fechaDocumento: fechaDocumento,
                proteccionSalud: data.proteccionSalud,
                proteccionSaludString: data.proteccionSaludString,
                proteccionSaludArray:data.proteccionSaludArray,
                idCarga:idCarga,
                idAfiliado:idUsuario,
                idUsuarioSesion:idUsuarioSesion
            },
            { headers: this.armaCabecera() }).toPromise();
    }

    eliminarDocumentoAyudaMedica(idDocumento: any ) {
        
        return this.http.post(`${environment.urlApiAyudaMedica}/ayudamedica/eliminadocumento/${idDocumento}`,    
        {
            idDocumento: idDocumento        
        },
        { headers:this.armaCabecera() }).toPromise();
    }

 
    editarAyudaMedica(data: any,idUsuario: any,idUsuarioSesion: any){
        return this.http.put(`${environment.urlApiAyudaMedica}/ayudamedica`,               
               
                {
                    idUsuario: idUsuario,
                    idUsuarioSesion:idUsuarioSesion,
                    id: data.idPostulacion,
                    archivoAdjunto:data.archivo,
                    idProducto: 6,
                    ayudaMedica: {      
                       totalPagar: data.totalPagar,
                       totalCopago: data.totalCopago,
                       porcentajeRebaja: data.porcentajeRebaja,
                       idAyudaMedica:data.idAyudaMedica,
                       observacion:data.observacion                           
                    }
                },
                { headers:this.armaCabecera() }).toPromise();
    }

    editarAyudaMedicaPostGuardarDocumento(dataTemp: any,idUsuarioSesion: any){
       
        return this.http.put(`${environment.urlApiAyudaMedica}/ayudamedica`,    
                {
                    id: dataTemp.idPostulacion,
                    idProducto: 6,
                    idUsuarioSesion: idUsuarioSesion,
                    ayudaMedica: {      
                       totalPagar: dataTemp.totalPagar,
                       totalCopago: dataTemp.totalCopago,   
                       porcentajeRebaja:dataTemp.porcentajeRebaja,            
                       idAyudaMedica:dataTemp.idAyudaMedica               
                    }
                },
                { headers:this.armaCabecera() }).toPromise();
    }


    traeDocumentos(documento: any)
    {
        return this.http.get(`${environment.urlApiAyudaMedica}/ayudamedica/documentos/${documento}`,
        { headers:this.armaCabecera() }).toPromise();
    }


    creaCargaMasivaArchivos(archivo:any,idAyuda:any)
    {
   
        let file:FormData = new FormData()    
        file.append('file', archivo.archivo, archivo.archivo.name) 
        return this.http.post(`${environment.urlApiAyudaMedica}/ingresar/archivo/${idAyuda}`, {file},
        { headers: this.armaCabecera() } ).toPromise()
    }
   
    solicitar(ayudas:any,documentosAyuda:any,afiliado:any, totalCopago:any,totalPagar:any,tipoEvento:any,idCarga:any,idUsuarioSesion:any){
       
        return this.http.post(`${environment.urlApiAyudaMedica}/solicitar/ayuda/`,
        {
            idProducto:6,
            idUsuario: afiliado,
            idUsuarioSesion:idUsuarioSesion,
            idCarga: idCarga,
            archivoAdjunto:ayudas.archivo,
            ayudaMedicaDTO: {
                fechaEvento: ayudas.fechaEvento,
                totalPagar: ayudas.totalPagar,
                totalCopago: ayudas.totalCopago,
                tipoEvento:tipoEvento,
                documentosAyudasDTO:documentosAyuda
            }
        }, { headers: this.armaCabecera() }).toPromise();
    }
 
    validarDocumento(documentosAyuda:any,fechaDocumentoTemp:any, usuarioIdSel:any, idCarga:any){
  
        return this.http.post(`${environment.urlApiAyudaMedica}/validar/documento/`,
        {
            idAfiliado: usuarioIdSel,
            idCarga: idCarga,
            documentosAyudasDTO: [{
                tipoEvento:documentosAyuda.tipoEvento,
                tipoDocumento: documentosAyuda.tipoDocumento,
                afiliado: documentosAyuda.afiliado,
                beneficiario:documentosAyuda.beneficiario,
                fechaDocumento:fechaDocumentoTemp,
                nroDocumento: documentosAyuda.nroDocumento,
                rutPrestador:documentosAyuda.rutPrestador.split('-')[0]
            }]
        }, { headers: this.armaCabecera() }).toPromise();
    }

    
    
    verArchivo(idAyuda:any){
        return this.http.get(`${environment.urlApiAyudaMedica}/ayuda/${idAyuda}/archivo-adjunto/`,
        { headers:this.armaCabecera() }).toPromise()
    }
    eliminarAyuda(idAyuda: any){
        return this.http.get(`${environment.urlApiAyudaMedica}/eliminar/${idAyuda}/ayuda/`
        , { headers: this.armaCabecera() }).toPromise();
    }
    eliminarAyudasIngresadas(afiliado: any, beneficiario:any){
        return this.http.post(`${environment.urlApiAyudaMedica}/eliminarAyudasIngresadas/`,
        { 
            filtroIngresado:true,
            idAfiliado:afiliado,
            idCarga:beneficiario
        }, { headers: this.armaCabecera() }).toPromise(); 
    }
    motivoRechazo(idProducto: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/motivoRechazo/productos/${idProducto}/`,
               { headers:this.armaCabecera() }).toPromise()
    }
    rechazarPostulacion(idPostulacion: any, idMotivoRechazo: any, motivoRechazo: any, comentarioRechazo: any)
    {
        return  this.http.post(`${environment.urlApiAyudaMedica}/rechazar/postulacion/`,
        {
            id: idPostulacion,
            estado: 'RECHAZADA',
            idMotivoRechazo: idMotivoRechazo,
            comentarioMotRechazo: comentarioRechazo,
            motivoRechazo: motivoRechazo
        },
        { headers:this.armaCabecera() } ).toPromise()
    }
    aprobarPostulacion(idPostulacion:any,usuario:any){
   
        return this.http.post(`${environment.urlApiAyudaMedica}/aprobar/postulacion/`,
               { idPostulacion: idPostulacion }, { headers:this.armaCabecera() } ).toPromise();
    }
    editarPostulacion(idPostulacion:any,datos:any){
  
        return  this.http.post(`${environment.urlApiAyudaMedica}/editar/postulacion/`,
        {
            idPostulacion: idPostulacion,
            ayudasMedicasDTO: datos.ayudasMedicas
        },
        { headers:this.armaCabecera() } ).toPromise();
    }
    

    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}
